<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-share-nodes icon"></i>
        <span>Minhas redes sociais</span>
      </h1>
      <router-link :to="{ name: 'socialPageCreate' }">
        <PrimaryButton class="px-5" icon="fa-solid fa-solid fa-plus">Nova rede social</PrimaryButton>
      </router-link>
    </div>
  </div>

  <div v-if="!loading || pages.data" class="align p-4 space_title">

    <div class="card">
      <div class="table_container">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome</th>
            <th>URL</th>
            <th>Data de criação</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(page, key) in pages.data" :key="key">
            <td>
              {{ page.id }}
            </td>
            <td>
              {{ page.name }}
            </td>
            <td>
              {{ page.url }}
            </td>
            <td>
              {{ $dateFormat(page.created_at) }}
            </td>
            <td class="actions">
                <router-link :to="{ name: 'socialPageEdit', params: { id: page.id }}">
                  <button class="btn btn-secondary">
                    <i class="fa-regular fa-edit"></i>
                  </button>
                </router-link>
                
                <a @click="openDestroyPageModal(page.id)">
                  <button class="btn btn-secondary">
                    <i class="fa-regular fa-trash"></i>
                  </button>
                </a>
            </td>
          </tr>
          <tr class="no_result" v-if="pages.data && !pages.data.length">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>

    <ListPagination class="mt-4" :links="pages.links" />
  </div>

  <ModalDialog v-model="showDestroyPageModal">
    <h6>Deseja realmente remover este registro?</h6>

    <div class="modal_actions">
      <WhiteButton>Cancelar</WhiteButton>
      <PrimaryButton class="red" @click="deletePage()">Remover</PrimaryButton>
    </div>
  </ModalDialog>
</template>
  
<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import WhiteButton from '@/components/WhiteButton.vue'
import { onBeforeMount, ref, watch } from 'vue';
import { useSocialStore } from '@/stores/SocialStore'
import { storeToRefs } from 'pinia';
import ListPagination from '@/components/ListPagination.vue'
import { inject } from 'vue';
import { useRoute } from 'vue-router';
import ModalDialog from '@/components/ModalDialog.vue';
import { useToast, TYPE } from "vue-toastification";
const toast = useToast();

const loader = inject('$loader');
const loading = ref(false);

const route = useRoute();
const socialStore = useSocialStore();
const { pages, filter } = storeToRefs(socialStore);


onBeforeMount(() => {
  loadPages();
});

watch(() => route.query.page, (newPage, oldPage) => {
  if (newPage !== oldPage) {
    window.scrollTo(0, 0);
    loadPages();
  }
});

async function loadPages() {
  loader.show();
  loading.value = true;

  filter.value.page = parseInt(route.query.page);
  filter.value.limit = 10;

  await socialStore.getPages();

  loader.hide();
  loading.value = false;
}

async function deletePage(){
  const formResult = await socialStore.deletePage(pageIdToDestroy.value);
      if(formResult.success){
        toast('Rede social removida', { type: TYPE.SUCCESS, timeout: 6000 });
        loadPages();
      }
      else {
        toast('Ocorreu um erro ao remover o registro', { type: TYPE.ERROR, timeout: 6000 });
      }

      showDestroyPageModal.value = false;
}


const showDestroyPageModal = ref(false);
const pageIdToDestroy = ref(null);

function openDestroyPageModal(id) {
  pageIdToDestroy.value = id;
  showDestroyPageModal.value = true;
}
</script>